import { AuthError } from '@supabase/supabase-js';

export const getAuthErrorMessage = (error: unknown): string => {
  if (error instanceof AuthError) {
    switch (error.message) {
      case 'Invalid login credentials':
        return 'Invalid email or password';
      case 'Email not confirmed':
        return 'Please verify your email address';
      default:
        return 'An error occurred during sign in';
    }
  }
  
  if (error instanceof Error) {
    return error.message;
  }
  
  return 'An unexpected error occurred';
};

export const getDatabaseErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    if (error.message.includes('duplicate key')) {
      return 'This record already exists';
    }
    if (error.message.includes('foreign key')) {
      return 'This operation would break data relationships';
    }
    return error.message;
  }
  return 'A database error occurred';
};